import * as tslib_1 from "tslib";
import { ElementRef } from '@angular/core';
import { ItmAbstractControl } from '../itm-abstract-control';
var ItmTextboxComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ItmTextboxComponent, _super);
    function ItmTextboxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.placeholder = "";
        _this.type = "text";
        return _this;
        // myOnChange(v: string) {
        // 	this.val = v;
        // 	this.onChange(v);
        // }
        // myOnBlur() {
        // 	this.onTouched()
        // }
    }
    ItmTextboxComponent.prototype.getControlRef = function () {
        return this.controlRef;
    };
    return ItmTextboxComponent;
}(ItmAbstractControl));
export { ItmTextboxComponent };
